/**
 * The persisted "which surface was I last on" bit, shared by the Sidebar's
 * mode switcher (which writes it) and the auth callback (which reads it to
 * decide where a returning login lands).
 *
 * Two consumers, one key — the callback used to hardcode /dashboard, which
 * dropped chat users back onto the build surface after every sign-in.
 */
export const WORKSPACE_MODE_KEY = 'fd:workspace-mode';

/**
 * General Chat (the Build ⇄ Chat switch and /chat) is hidden for launch
 * (founder 2026-10-14): UI only, the chat API stays up. Every /chat,
 * /chats and /dashboard link lands on /apps, the sidebar shows no mode
 * switch, and Chat-only shortcuts go to the builder. The chat inside a
 * build is a different thing and stays. False brings Chat back.
 */
export const CHAT_MODE_HIDDEN = true;

/** Where a returning user belongs. No stored mode (or no storage) → /apps. */
export function lastWorkspaceHref(): string {
  if (CHAT_MODE_HIDDEN) return '/apps';
  try {
    return localStorage.getItem(WORKSPACE_MODE_KEY) === 'chat' ? '/chat' : '/apps';
  } catch {
    return '/apps';
  }
}
